import { useCallback, useEffect, useState } from 'react';
import { getAllAutogiroMandate } from 'src/shared/services/autogiroMandateService';

/** Returns the number of unlinked autogiro mandates and a refetch function */
export const useAutogiroUnlinkedBadge = (): [number, () => void] => {
  const [count, setCount] = useState(0);

  const fetch = useCallback(() => {
    getAllAutogiroMandate({ pageIndex: 0, pageSize: 1, sortCol: 'autogiroMandate_id', sortDir: 'desc', filter: '', linkedFilter: 'unlinked' })
      .then((res) => {
        setCount(res.data.totalItems);
      })
      .catch(() => undefined);
  }, []);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return [count, fetch];
};
